import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableSkeleton from "../../common-components/TableSkeleton";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { BodyBuilder, NoPic } from "../../../exports/Images";
import {
  BiArrowsFullScreenIcon,
  ReceptionistIcon,
  TrainerIcon,
} from "../../../images/icons/icons";
import { stringToColor } from "../../../data/Constants";
import ReadMoreText from "../../common-components/custom-comps/ReadMoreText";
import { formatDateTime } from "../../common-data/Converts";

const StaffProfilesListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const { staffProfiles, staffProfilesLoading, staffProfilesError } =
    useSelector((state) => state.prospects);

  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  useEffect(() => {
    if (
      !staffProfilesLoading &&
      !staffProfilesError &&
      staffProfiles?.status &&
      staffProfiles?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: staffProfiles.data,
        pagination:
          staffProfiles?.pagination?.length > 0 ? staffProfiles.pagination : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [staffProfilesLoading, staffProfilesError, staffProfiles]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "Staff",
      formatter: (_, row) => (
        <>
          <div className="emeberDetailsRowContainer">
            {row?.existing_profile ? (
              <img
                src={row?.existing_profile || BodyBuilder}
                alt={row?.name || "N/A"}
                className="image"
                onClick={() =>
                  row?.existing_profile &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "image_view",
                    image: row?.existing_profile,
                    rowData: row,
                  }))
                }
              />
            ) : (
              <div
                className="nameInitials"
                style={{ backgroundColor: stringToColor(row?.name || "") }}
              >
                <span className="nameLetters">
                  <span className="nameLetters">
                    {row?.name
                      ?.split(" ")
                      .map((namePart, index) =>
                        index === 0 ||
                        index === row?.name?.split(" ").length - 1
                          ? namePart.charAt(0).toUpperCase()
                          : null
                      )}
                  </span>
                </span>
              </div>
            )}
            <span className="tb-data text-start">
              {row?.name || "NA"}
              <br />
              {(row?.mobile || row?.email) && (
                <small className="lowercase">
                  {row?.mobile || ""}
                  <br />
                  {row?.email || ""}
                </small>
              )}
            </span>
          </div>

          <br />

          <span
            className="tb-data withIcon minWidth100 withPadding borderRdius64px"
            style={{
              backgroundColor:
                row?.account_type === "receptionist" ? "#EBE8FE" : "#FEF0E8",
              color: "#0C0B0B",
            }}
          >
            <div className="icon">
              {row?.account_type === "receptionist" ? (
                <ReceptionistIcon />
              ) : (
                <TrainerIcon />
              )}
            </div>
            <span className="label">
              {row?.account_type === "receptionist"
                ? "Sales Executives"
                : row?.account_type?.replace(/_/g, " ")}
            </span>
          </span>
        </>
      ),
    },
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "profile",
      text: "Requested Profile",
      formatter: (_, row) => {
        return (
          <div className="flexCenter minWidth150">
            <div className="tb-data-img">
              <img
                src={row?.profile || NoPic}
                alt={row?.name || "NA"}
                className="image"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName:
                      row?.status === "pending" ? "view_details" : "image_view",
                    image: row?.profile || NoPic,
                    rowData: row,
                  }));
                }}
              />

              <button
                type="button"
                className="abs-zoom"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName:
                      row?.status === "pending" ? "view_details" : "image_view",
                    image: row?.profile || NoPic,
                    rowData: row,
                  }));
                }}
                disabled={!row?.profile}
                style={{
                  opacity: row?.profile ? "1" : "0.5",
                  cursor: row?.profile ? "pointer" : "not-allowed",
                }}
              >
                <BiArrowsFullScreenIcon />
              </button>
              {/* <button
                type="button"
                className="abs-zoom abs-del"
                onClick={() => {
                  const uidFilter = {
                    uid: row?.banner_id || "",
                  };

                  handleDelete(uidFilter);
                }}
                disabled={!row?.profile}
                style={{
                  opacity: row?.profile ? "1" : "0.5",
                  cursor: row?.profile ? "pointer" : "not-allowed",
                }}
              >
               <BiTrash3FillIcon />
              </button> */}
            </div>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "approval status",
      formatter: (_, row) => (
        <span
          className={`pp-employee-payroll-badge ${
            row?.status === "approved"
              ? "pp-green-badge"
              : row?.status === "pending"
              ? "pp-yellow-badge"
              : "pp-red-badge"
          }`}
          style={{ fontSize: "16px" }}
        >
          {row?.status || "NA"}
        </span>
      ),
    },
    {
      dataField: "remarks",
      text: "remarks",
      formatter: (_, row) => {
        return (
          <ReadMoreText
            text={row?.remarks}
            maxLength={30}
            className="tb-data"
          />
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "action",
    //   text: "Action",
    //   formatter: (_, row) => (
    //     <div className="actionButtonContainer">
    //       <button
    //         account_type="button"
    //         className="actionBtn icon view withText"
    //         disabled={false}
    //         onClick={() =>
    //           setModValues((prevs) => ({
    //             ...prevs,
    //             isModOpen: true,
    //             modName: "view_details",
    //             rowData: row,
    //           }))
    //         }
    //       >
    //         review
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mb30">
      {staffProfilesLoading ? (
        <TableSkeleton />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default StaffProfilesListings;
